import { FC } from 'react';

import { Trash2 } from 'lucide-react';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { promoCodeService } from 'v2/api/promoCodeService';
import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';
import { PromoCodeModel } from 'v2/types/PromoCodeModel';
import { handleHttpError } from 'v2/utils';

interface PromoCodeTableActionColumnProps {
  promoCode: PromoCodeModel;
  onRevalidate: VoidFunction;
}

export const PromoCodeTableActionColumn: FC<PromoCodeTableActionColumnProps> = ({ promoCode, onRevalidate }) => {
  const { trigger } = useSWRMutation(['deletePromoCode', promoCode.name], promoCodeService.deletePromoCode, {
    onSuccess: () => {
      onRevalidate();
    },
    onError: handleHttpError,
  });

  return (
    <Popconfirm message="Are you sure that you want to delete this promo code?" onConfirm={trigger}>
      <Tooltip title="Delete" placement="top">
        <IconButton color="error">
          <Trash2 width={22} height={22} />
        </IconButton>
      </Tooltip>
    </Popconfirm>
  );
};
